import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: { type: Number, default: 4000 } }

  connect() {
    this.remaining = this.durationValue
    this.visibilityChanged = () => (document.hidden ? this.pause() : this.resume())
    document.addEventListener("visibilitychange", this.visibilityChanged)
    this.resume()
  }

  disconnect() {
    this.pause()
    document.removeEventListener("visibilitychange", this.visibilityChanged)
  }

  pause() {
    if (!this.timeout) return

    clearTimeout(this.timeout)
    this.timeout = null
    this.remaining -= Date.now() - this.startedAt
  }

  resume() {
    if (this.timeout || document.hidden || this.dismissing) return

    this.startedAt = Date.now()
    this.timeout = setTimeout(() => this.dismiss(), this.remaining)
  }

  async dismiss() {
    this.pause()
    this.dismissing = true
    this.element.dataset.dismissing = ""

    await Promise.allSettled(this.element.getAnimations().map((animation) => animation.finished))
    this.element.remove()
  }
}
